<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="29.935" height="26" viewBox="0 0 29.935 26">
    <g>
      <path
        d="M3.921 0h22.113a3.926 3.926 0 0 1 3.911 3.911v11.575a3.926 3.926 0 0 1-3.911 3.914H12.988l-4.442 6.226a.89.89 0 0 1-1.613-.515v-5.714H3.921A3.926 3.926 0 0 1 .01 15.486V3.911A3.926 3.926 0 0 1 3.921 0zm3.251 7.026A2.477 2.477 0 1 1 4.7 9.5a2.477 2.477 0 0 1 2.472-2.474zm15.61 0A2.477 2.477 0 1 1 20.3 9.5a2.477 2.477 0 0 1 2.477-2.477zm-7.8 0A2.477 2.477 0 1 1 12.5 9.5a2.477 2.477 0 0 1 2.477-2.477z"
        transform="translate(-.01)"
        style="fill-rule: evenodd"
      />
    </g>
  </svg>
</template>
